<template>
    <div class="app-container">
      <BjPage ref="BjPage" :label-width="'80px'" :query-params="queryParams" :col-span="colSpan" :get-action="queryApi" :search-btn-hide="true" :before-reset-search="beforeResetSearch" @showSetting="SortableTable.show" @header-dragend="SortableTable.handleHeaderDragend" @afterFetchOriginalData="afterFetchOriginalData" @header-contextmenu="SortableTable.handleHeaderContextmenu">
        <!-- <template v-slot:baseForm>
          <el-col :span="colSpan">
            <el-form-item :label="$t('screenWMS.waveId')" prop="waveId">
              <BjInputNumber v-model="queryParams.waveId" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('screenWMS.waveId')" clearable @keyup.enter.native="handleQuery" />
            </el-form-item>
          </el-col>
        </template> -->
  
        <template v-slot:tableOperation>
          <el-col>
            <el-button type="primary" class="main-btn" @click="onAdd">{{ $t('billingPage.create') }}</el-button>
          </el-col>
        </template>

        <template v-slot:tableColumn>
          <template v-for="(col, index) in dropCols">
            <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item">
              <template slot-scope="scope">
                <template v-if="false" />
                <template v-else-if="col.prop === 'basketNumber'">
                  {{ scope.row.basketNumberStart }} - {{ scope.row.basketNumberEnd }}
                </template>
                <template v-else-if="col.prop === 'largeScreenAddress'">
                  <span style="color: #3173d0;cursor:pointer" @click="toWavePage(scope.row[col.prop])">{{ scope.row[col.prop] }}</span>
                </template>
                <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
              </template>
            </el-table-column>
            <el-table-column v-if="col.prop === 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || 'right'" align="center">
              <template slot-scope="props">
                <el-button type="text" class="edit-btn" @click="onEdit(props.row)">{{ $t('editText') }}</el-button>
                <el-button type="text" class="delete-btn" @click="onDelete(props.row)">{{ $t('delText') }}</el-button>
              </template>
            </el-table-column>
          </template>
        </template>
      </BjPage>
      <!-- 新增/编辑弹窗 -->
      <DataForm ref="DataForm" @reFresh="reFresh" @batchDeleteApi="batchDeleteApi" />
    </div>
  </template>
  
  <script>
    import pageMiXin from '@/utils/page-mixin.js';
    import { waveApi } from '@/api';
    import DataForm from './DataForm.vue';

    export default {
      name: 'WMSSortingStation',
      components: {DataForm,},
      mixins: [pageMiXin],
      data() {
        return {
          colSpan: 4,
          queryApi: waveApi.getSortingStationList,
          queryParams: {
            waveId: null,
          },
          labelList: [
            { label: this.$t('screenWMS.sortingStation'), prop: 'sortingStationNumber', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.shelves'), prop: 'shelvesNumber', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.basket'), prop: 'basketNumber', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.address'), prop: 'largeScreenAddress', isCheck: true, disabled: false, },
            { label: this.$t('screenWMS.Printer'), prop: 'printerInformation', isCheck: true, disabled: false },
            { label: this.$t('table.operationText'), prop: 'bjTableAction', isCheck: true, disabled: false, width: 150 },
          ],
        };
      },
      computed: {},
      methods: {
        // 过滤页面数据
        afterFetchOriginalData(data) {
          data.content = data.records
          return data;
        },

        /** 新增分拣台 */
        onAdd() {
          this.$refs.DataForm.show();
        },

        /** 跳转大屏 */
        toWavePage(url) {
          // 定义URL字符串
          const urlString = url;
          // 使用split方法以斜杠为分隔符拆分URL字符串
          const urlParts = urlString.split('/');
          // 获取拆分后数组的最后一个元素
          const lastPart = urlParts[urlParts.length - 1];
          // 假设最后一个元素总是数字，直接打印输出
          // console.log(lastPart);
          window.open(
            // 大屏路由地址 以及 附带参数
            `/#/wave?SortingStation=${lastPart}`,
            '_blank'
          )
        },

        /** 编辑分拣台 */ 
        onEdit(row) {
          this.$refs.DataForm.show(row);
        },

        // 删除分拣台
        onDelete(row) {
          this.$confirm(this.$t('InternalSalesOrderDetails.want'), this.$t('toast.hintText'), {
            confirmButtonText: this.$t('toast.okText'),
            cancelButtonText: this.$t('toast.cancelText'),
            type: 'warning',
          })
            .then(() => {
              waveApi.delSortingStation({id:row.id}).then(res => {
                if (res.code == 200) {
                  this.$message.success(this.$t('toast.operationSuccessText'));
                  setTimeout(() => {
                    this.reFresh();
                  }, 500);
                }else{
                  this.$message.error(res.msg);
                }
              });
            })
            .catch(() => {});
        },

        beforeResetSearch() {
          // this.queryParams.waveId = null;
          return new Promise(resolve => {
            resolve();
          });
        },
      },
    };
  </script>
  <style lang="scss" scoped>
  .el-icon-s-flag {
    float: right;
    line-height: 34px;
  }
  </style>
  